export const PAPER_CHECK_HISTORY = 'paper-check-history';
export const PAPER_CHECK = 'paper-check';
export const PAPER_CHECK_NEW_HOME = 'dropdown-paper-check-new-home';
export const PAPER_CHECK_PUBLISHED_HOME  = 'dropdown-paper-check-published-home';
export const PAPER_CHECK_NEW = 'dropdown-paper-check-new-paper-check';
export const PAPER_CHECK_PUBLISHED  = 'dropdown-paper-check-published-paper-check';
